export default "__VITE_ASSET__CkbFlwou__"